import React from 'react'
import BreadCrumb from '../../components/Global/Breadcrumb/BreadCrumb'
import AllBlogsPage from './AllBlogsPage'

function BlogsPage() {
  return (
    <>
      <AllBlogsPage />
    </>
  )
}

export default BlogsPage
